import { render, staticRenderFns } from "./file.vue?vue&type=template&id=32c6ba76&"
import script from "./file.vue?vue&type=script&lang=ts&"
export * from "./file.vue?vue&type=script&lang=ts&"
import style0 from "./file.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports